import { Component, Input, OnInit } from '@angular/core';

import { IItemRenderer } from '../../interfaces/item-renderer.table';

@Component({
  selector: 'opt-percent-item-renderer',
  templateUrl: './percent-item-renderer.component.html',
  styleUrls: ['./percent-item-renderer.component.scss'],
})
export class PercentItemRendererComponent implements OnInit, IItemRenderer {
  @Input() id: string;
  @Input() value: number;

  private readonly locale: string = 'en-US';
  private readonly options: Intl.NumberFormatOptions = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'percent',
  };

  constructor() {}

  get formattedValue(): string {
    return this.value.toLocaleString(this.locale, this.options);
  }

  ngOnInit(): void {}
}
